import type { StockAnalysisLocale } from './hanggent/products/stockAnalysis';

type Messages = {
  title: string;
  eyebrow: string;
  search: string;
  watch: string;
  compare: string;
  navigation: string;
  description: string;
  dataStatus: string;
  configureSource: string;
  searchNatural: string;
  importData: string;
  compareSelected: string;
  priceHistory: string;
};

const en: Messages = {
  title: 'AI Real Estate Assistant',
  eyebrow: 'Hanggent real estate research workspace',
  search: 'Search homes',
  watch: 'Neighborhood watch',
  compare: 'Compare homes',
  navigation: 'Real estate workspace navigation',
  description: 'Search, compare, and monitor imported listings with recorded price history and source coverage.',
  dataStatus: 'Data status',
  configureSource: 'Configure data source',
  searchNatural: 'Search in natural language',
  importData: 'Import listing data',
  compareSelected: 'Compare selected',
  priceHistory: 'Price history',
};

const zhHans: Messages = {
  title: 'AI 房产助手',
  eyebrow: 'Hanggent 房产研究工作区',
  search: '找房',
  watch: '社区监控',
  compare: '房源对比',
  navigation: '房产研究导航',
  description: '基于已导入房源、价格历史与来源覆盖信息，搜索、对比和监控房产。',
  dataStatus: '数据状态',
  configureSource: '配置数据来源',
  searchNatural: '自然语言找房',
  importData: '导入房源数据',
  compareSelected: '对比已选房源',
  priceHistory: '价格历史',
};

const zhHant: Messages = {
  title: 'AI 房產助理',
  eyebrow: 'Hanggent 房產研究工作區',
  search: '找房',
  watch: '社區監控',
  compare: '房源比較',
  navigation: '房產研究導覽',
  description: '透過已匯入房源、價格歷史與來源覆蓋資訊，搜尋、比較及監控房產。',
  dataStatus: '資料狀態',
  configureSource: '設定資料來源',
  searchNatural: '自然語言找房',
  importData: '匯入房源資料',
  compareSelected: '比較已選房源',
  priceHistory: '價格歷史',
};

export const realEstateTranslations: Record<StockAnalysisLocale, Messages> = {
  'en-US': en,
  'zh-Hans': zhHans,
  'zh-Hant': zhHant,
  de: en,
  ko: en,
  ja: en,
  fr: en,
  ru: en,
  it: en,
  ar: en,
  es: en,
  hi: en,
};
